import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';

export interface RouteAlert {
  message: string;
  type?: 'success' | 'info' | 'warning' | 'danger';
}

@Injectable({ providedIn: 'root' })
export class AlertService {
  private alertSubject = new BehaviorSubject<RouteAlert | null>(null);

  get alert$(): Observable<RouteAlert | null> {
    return this.alertSubject.asObservable();
  }

  constructor(private router: Router) {}

  show(alert: RouteAlert): void {
    this.alertSubject.next(alert);
  }

  clear(): void {
    this.alertSubject.next(null);
  }

  setAlertOnNavigate(route: string, alert: RouteAlert, extras: any = {}): void {
    this.router.navigate([route], {
      ...extras,
      state: { ...extras.state, alertMessage: alert.message, alertType: alert.type || 'info' }
    });
  }

  getRouteAlert(): RouteAlert | null {
    const nav = this.router.getCurrentNavigation();
    if (!nav?.extras?.state?.['alertMessage']) return null;

    return {
      message: nav.extras.state?.['alertMessage'],
      type: nav.extras.state?.['alertType'] || 'info'
    };
  }
}
